export function data() {
  return {
    settingFilters: false,
    dependents: {
      fornecedor: ['produto', 'sub_produto'],
    },
    gates: [],
    params: {
      data_agendamento_inicio: {
        value: '',
        visible: false,
      },
      data_agendamento_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_triagem_inicio: {
        value: '',
        visible: false,
      },
      data_triagem_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_cota_inicio: {
        value: '',
        visible: false,
      },
      data_cota_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_pedido_inicio: {
        value: '',
        visible: false,
      },
      data_pedido_fim: {
        value: '',
        visible: false,
        until: true,
      },
      embalagem: {
        value: '',
        visible: false,
        until: true,
      },
      numero_pedido: {
        value: '',
        visible: false,
        until: false,
      },
      data_pesagem_entrada_inicio: {
        value: '',
        visible: false,
      },
      data_pesagem_entrada_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_pesagem_saida_inicio: {
        value: '',
        visible: false,
      },
      data_pesagem_saida_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_saida_patio_inicio: {
        value: '',
        visible: false,
      },
      data_saida_patio_fim: {
        value: '',
        visible: false,
        until: true,
      },
      data_conclusao_inicio: {
        value: '',
        visible: false,
      },
      data_conclusao_fim: {
        value: '',
        visible: false,
        until: true,
      },
      gate: {
        value: '',
        visible: false,
      },
      proprietario: {
        value: '',
        visible: false,
      },
      fornecedor: {
        value: '',
        visible: false,
        get: this.getFornecedores,
      },
      produto: {
        value: '',
        visible: false,
      },
      sub_produto: {
        value: '',
        visible: false,
      },
      cliente: {
        value: '',
        visible: false,
        get: this.getClientes,
      },
      transportadora: {
        value: '',
        visible: false,
        get: this.getTransportadoras,
      },
      terminal: {
        value: '',
        visible: false,
        get: this.getContratos,
      },
      regiao: {
        value: '',
        visible: false,
        get: this.getRegioes,
      },
      representante: {
        value: '',
        visible: false,
        get: this.getRepresentantes,
      },
      motorista: {
        value: '',
        visible: false,
        get: this.getMotoristas,
      },
      placa_cavalo: {
        value: '',
        visible: false,
      },
      eixo: {
        value: '',
        visible: false,
      },
      navio: {
        value: '',
        visible: false,
      },
      tipo_operacao: {
        visible: false,
        value: '',
      },
      servico_triado: {
        visible: false,
        value: '',
      },
      sequencia_pesagem: {
        visible: false,
        value: '',
        until: false,
      },
      public_id: {
        visible: false,
        value: '',
        until: false,
      },
      codigo_externo: {
        visible: false,
        value: '',
        until: false,
      },
    },
    allOptions: [
      'data_agendamento_inicio',
      'data_agendamento_fim',
      'data_triagem_inicio',
      'data_triagem_fim',
      'data_cota_inicio',
      'data_cota_fim',
      'data_pedido_inicio',
      'data_pedido_fim',
      'embalagem',
      'numero_pedido',
      'data_pesagem_entrada_inicio',
      'data_pesagem_entrada_fim',
      'data_pesagem_saida_inicio',
      'data_pesagem_saida_fim',
      'data_saida_patio_inicio',
      'data_saida_patio_fim',
      'data_conclusao_inicio',
      'data_conclusao_fim',
      'gate',
      'proprietario',
      'fornecedor',
      'produto',
      'sub_produto',
      'cliente',
      'transportadora',
      'terminal',
      'regiao',
      'representante',
      'motorista',
      'placa_cavalo',
      'eixo',
      'navio',
      'tipo_operacao',
      'servico_triado',
      'sequencia_pesagem',
      'public_id',
      'codigo_externo',
    ],
    servicos: [],
  }
}
